module.exports = __webpack_public_path__ + "fonts/Montserrat-LightItalic.428b230.ttf";